var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 240,
    viewBox: "0 0 162 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-263 295.838C-199.218 294.738 -135.082 283.949 -76.4537 258.807C-40.0861 243.197 -5.09425 221.863 24.3459 194.831C39.147 181.247 52.6148 166.168 64.1241 149.68C75.2767 133.691 88.5641 114.599 89.3934 94.708C89.9569 81.4828 85.2607 67.8562 75.6878 58.7066C66.1243 49.5398 51.605 45.4527 38.987 49.5074C26.3862 53.5714 16.7095 66.1933 17.3038 79.4177C17.95 94.1608 30.702 106.465 45.0256 110.047C59.3492 113.628 74.6151 109.906 87.932 103.557C126.923 84.9283 151.911 42.5318 151.959 -0.340648",
    stroke: "#0100C6",
    strokeWidth: 20,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector1.732b93d083b50531a0d77f50296a82cc.svg";
export { ForwardRef as ReactComponent };